import React from 'react';
import styles from '../styles/Coupon.module.css';

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const CouponTable = ({ coupons, onEdit, onDelete }) => (
  <div className={styles.tableWrapper}>
    <table className={styles.couponTable}>
      <thead>
        <tr>
          <th>Coupon Code</th>
          <th>Discount (%)</th>
          <th>Expiry Date</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {coupons.map((coupon) => (
          <tr key={coupon.id}>
            <td>{coupon.code}</td>
            <td>{coupon.discount}</td>
            <td>{formatDate(coupon.expiry)}</td>
            <td>
              <span className={coupon.status === 'Active' ? styles.activeBadge : styles.expiredBadge}>
                {coupon.status}
              </span>
            </td>
            <td>
              <button className={styles.editBtn} onClick={() => onEdit(coupon)}>Edit</button>
              <button className={styles.deleteBtn} onClick={() => onDelete(coupon.id)}>Delete</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default CouponTable;
